module.exports = __webpack_public_path__ + "img/caselist5.f8a2d691.jpg";